import Modal from 'react-native-modal';
import React from 'react';
import { View, TouchableOpacity, Text,  } from 'react-native';
import { widthPercentageToDP as wp } from 'react-native-responsive-screen';
import { StyleSheet } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';
import { colors } from '../../config';

export default ({
        isBottomSheetVisible, 
        setIsBottomSheetVisible, 
        children,
        title
    }:{
        isBottomSheetVisible: boolean, 
        setIsBottomSheetVisible: React.Dispatch<React.SetStateAction<boolean>>, 
        children: JSX.Element,
        title: string
    }): JSX.Element => {

    return (
        <Modal
            isVisible={isBottomSheetVisible}
            onDismiss={() => setIsBottomSheetVisible(false)}
            onBackdropPress={() => setIsBottomSheetVisible(false)}
            style={styles.modal}
        >
            <View style={styles.container}>
                <View style={styles.header}>
                    <View style={styles.smallBar}></View>

                    <View style={styles.titleContainer}>
                        <Text style={styles.title}>{title}</Text>
                        <TouchableOpacity onPress={() => setIsBottomSheetVisible(false)}>
                            <MaterialIcons name="close" size={25} color="#000000" />
                        </TouchableOpacity>
                    </View>
                    
                </View>
                {children}
            </View>
        </Modal>
    )
}

const styles = StyleSheet.create({
    modal:{
        margin: 0,
        justifyContent: "flex-end",
        borderTopLeftRadius: 15,
        borderTopRightRadius: 15,
    },
    container: {
        display: 'flex',
        width: wp("100%"),
        alignSelf: 'center',
        justifyContent: 'center',
        marginRight: 0,
        paddingHorizontal: 5,
        paddingVertical: 10,
        borderRadius: 10,
        backgroundColor: '#FFFFFF',
        shadowOffset: {
        width: 0,
        height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 3.84,
        zIndex: 1,
    },

    header: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        paddingHorizontal: 20,
        paddingVertical: 5,
        marginBottom: 10
    },
    smallBar: {
        width: 50,
        height: 5,
        borderRadius: 5,
        backgroundColor: colors.gray,
        marginBottom: 10,
    },
    titleContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 5,
        width: '100%',
    },
    title: {
        fontSize: 18,
        fontWeight: '700',
        color: colors.black,
    },
});